// src/routes/dashboard/components/DashboardHeader.tsx
import React from 'react';
import { Group, ActionIcon, Text, Tooltip, Button } from '@mantine/core';
import { IconRefresh, IconChartBar } from '@tabler/icons-react';
import { useNavigate } from '@tanstack/react-router';
import { GinoriTitle } from '../../../components/ui';

interface DashboardHeaderProps {
  generatedAtUtc?: string;
  canSeeAnalytics: boolean;
  isFetching: boolean;
  onRefresh: () => void;
}

export function DashboardHeader({ generatedAtUtc, canSeeAnalytics, isFetching, onRefresh }: DashboardHeaderProps) {
  const navigate = useNavigate();
  const updatedLabel = formatUpdatedAt(generatedAtUtc);

  return (
    <Group justify="space-between" align="flex-end" mb="md" wrap="wrap">
      <GinoriTitle elegant subtitle="Cosa richiede attenzione oggi">
        Dashboard
      </GinoriTitle>

      <Group gap="sm" mb="lg">
        {updatedLabel && (
          <Text size="xs" c="dimmed">
            Aggiornato alle {updatedLabel}
          </Text>
        )}
        <Tooltip label="Aggiorna">
          <ActionIcon variant="light" color="gray" onClick={onRefresh} loading={isFetching}>
            <IconRefresh size={16} />
          </ActionIcon>
        </Tooltip>
        {canSeeAnalytics && (
          <Button
            variant="light"
            size="xs"
            leftSection={<IconChartBar size={14} />}
            onClick={() => navigate({ to: '/analytics' })}
          >
            Vai ad Analytics
          </Button>
        )}
      </Group>
    </Group>
  );
}

function formatUpdatedAt(iso?: string): string | null {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  return d.toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' });
}
